module.exports = __webpack_public_path__ + "static/media/gain_influence.147bc9b7.png";